/**
 * Wire-level GitHub App role expected by vcs-service. `null` appears on
 * `AppInstallationRecord` for legacy rows with no matching credential.
 */
export type AppRole = 'read' | 'write';

/**
 * Maps each FOSSA app onto its vcs-service GitHub App role.
 */
export const VCS_APP_ROLE = {
  fossabot: 'write',
  fossaCore: 'read',
} as const satisfies Record<string, AppRole>;

export type VcsApp = keyof typeof VCS_APP_ROLE;

export const DEFAULT_VCS_APP: VcsApp = 'fossabot';

/** User-facing name + logo for an app, shown in install CTAs. */
export type AppDisplay = { name: string; logo: string };

/**
 * User-facing name and logo for each app, shown in install CTAs.
 */
export const VCS_APP_DISPLAY: Record<VcsApp, AppDisplay> = {
  fossabot: { name: 'fossabot', logo: '/img/fossabot-logo-color.svg' },
  fossaCore: { name: 'FOSSA', logo: '/img/fossa-logo-circle.svg' },
};
